import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import GsAddressValidation from './gs-address-validation.vue';

type AddressValidator = InstanceType<typeof GsAddressValidation>;
type AddressValidatorOrChild = AddressValidator | { $parent: AddressValidator };

function isAddressValidator(item: AddressValidatorOrChild): item is AddressValidator {
  return 'validate' in item;
}

// Validates multiple gs-address-validation
// gs-address-validation components that are collected using p-parent can also be processed
// The errors on the supplied model get appended with the validation errors
// eslint-disable-next-line import/prefer-default-export
export async function validateAddresses(addressValidators: AddressValidatorOrChild[], model: BaseModel<any> | undefined) {
  const promises = addressValidators.map((addressValidator) => ((isAddressValidator(addressValidator) ? addressValidator : addressValidator.$parent).validate)());
  const validation = await Promise.all(promises);

  const result = validation.reduce((result1, result2) => ({
    isValid: result1.isValid && result2.isValid,
    errors: [...result1.errors, ...result2.errors],
  }), { isValid: true, errors: [] });

  model?.errors.push(...result.errors.map((e) => ({
    message: e,
    keyword: '',
    propName: '',
    path: [],
    params: {},
  })) ?? []);

  return result.isValid;
}
